var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"catalogue_page mt20 current_page",class:{ cursor_pointer: !_vm.catalogue.length },on:{"click":_vm.handleEmpty}},[_vm._v(" "+_vm._s(_vm.catalogue.length > 0 ? '' : '--')+" "),_vm._l((_vm.catalogue),function(item,index){return _c('li',{key:index,staticClass:"catalogue_item PingFangMedium",class:{
                current: _vm.activeName == item.local_id,
                teach: _vm.articleType == 'exercise',
                work: _vm.articleType == 'courseware',
                temp: _vm.articleType == 'template',
                catalogue_level_1: item.level == 1,
                catalogue_level_2: item.level == 2,
                catalogue_level_3: item.level == 3,
            },on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v(" "+_vm._s(item.name ? item.name : '--')+" ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }